import React, { PropsWithChildren } from "react";
import Button from "components/utils/Button";
import { ButtonSize, Color } from "utils/types/util.types";
import { email } from "utils/constants/constants";
import { useScreenSize } from "utils/hooks/useScreenSize";
import { isNotNull } from "utils/types/typeguards";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

type Props = {
	buttonSize?: ButtonSize
}

function EmailButton({
	buttonSize,
	children,
}: PropsWithChildren<Props>) {

	const screenSize = useScreenSize();

	const { t } = useTranslation();

	const { enqueueSnackbar } = useSnackbar();

	const getButtonSize = () => {
		if (isNotNull(buttonSize)) return buttonSize;
		return screenSize.width > 678 ? ButtonSize.LARGE : ButtonSize.SMALL;
	}

	const onClick = () => {
		enqueueSnackbar(t("snackbar.copyMessage.email"), { variant: "success", preventDuplicate: true })
		navigator.clipboard.writeText(email)
	}

	return (
		<Button
			color={ Color.PURPLE }
			link={ `mailto:${email}` }
			onClick={ onClick }
			size={ getButtonSize() }
			tooltip={ { id: "contact-modal-button-email-tooltip", message: email } }
		>
			{ children }
		</Button>
	);
}

export default EmailButton;